import React, { useCallback, useMemo } from 'react'
import { isEmployeeRole, isViewOnlyUserRole } from '../../../utils/roles'
import useProfile from '../../../hooks/useProfile/useProfile'

import * as styles from './itemButtons.module.scss'
import { ItemButtonsProps } from './types'
import { ActionButton } from '..'

const ItemButtons = ({
   itemButtons = [],
   permissions = [],
   isItemModal,
}: ItemButtonsProps) => {
   const { profile } = useProfile()
   const userRoles = useMemo(() => profile?.Roles || [], [profile])
   const isEmployeeUser = useMemo(() => isEmployeeRole(userRoles), [userRoles])
   const isViewOnlyUser = useMemo(() => isViewOnlyUserRole(userRoles), [userRoles])

   const isPermitted = useCallback((perms: string[], value: string) => {
      if (!isEmployeeUser && !isViewOnlyUser) {
         if (value === '') return true // return as this doesn't require a permission or type
      }
      return perms.some((permission) => permission === value)
   }, [])

   return (
      <div
         className={`${styles.buttonsContainer} ${
            isItemModal ? styles.itemsModalButtonsContainer : ''
         }item-buttons`}
      >
         {itemButtons
            .filter((btn) => isPermitted(permissions, btn.type))
            .map((btn) => (
               <ActionButton
                  key={btn.title}
                  title={btn.title}
                  action={btn.action}
                  iconId={btn.name}
               />
            ))}
      </div>
   )
}

export default ItemButtons
